import { Collection } from 'modules/core/lib/mobx-rest'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import EmployeeGroup from 'modules/employees/store/models/EmployeeGroup'

class EmployeeGroups extends Collection<EmployeeGroup> {
  get cacheKey(): string {
    return 'employeeGroups'
  }

  model() {
    return EmployeeGroup
  }
}

const singleton: EmployeeGroups = new EmployeeGroups()

export const legalEntityEmployeeGroups = (legalEntity: LegalEntity) => {
  return singleton.filter({
    legal_entity_id: legalEntity.attributes.id,
  })
}

export default singleton
